document.addEventListener('DOMContentLoaded', function () {
	const buttons = document.querySelectorAll(
		'.fontes-renovaveis__container__row__nav-tabs__scroll__buttons__button'
	);

	

	const contents = document.querySelectorAll(
		'.fontes-renovaveis__container__row__nav-tabs__image-paragraph'
	);

	if (buttons.length > 0) {
		// iniciar com o primeiro botão com aparência de clicado
		buttons[0].classList.add(
			'fontes-renovaveis__container__row__nav-tabs__scroll__buttons__button-clicked'
		);

		// mudança de cor quando clicado e reseta os outros
		buttons.forEach(function (button) {
			button.addEventListener('click', function () {
				buttons.forEach(function (btn) {
					btn.classList.remove(
						'fontes-renovaveis__container__row__nav-tabs__scroll__buttons__button-clicked'
					);
				});
				this.classList.add(
					'fontes-renovaveis__container__row__nav-tabs__scroll__buttons__button-clicked'
				);

				// Esconde todos os conteúdos
				contents.forEach(function (content) {
					content.style.display = 'none';
				});

				// Mostra o conteúdo correspondente ao botão clicado
				const contentId = this.id.replace('btn', 'content');
				const contentToShow = document.getElementById(contentId);
				if (contentToShow) {
					contentToShow.style.display = 'flex';
				}
			});
		});
	}
});